// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5075) return "static/chunks/5075-d8d98ee91eb229c4.js";
	if (chunkId === 5875) return "static/chunks/5875-4f8e0a10d0141efb.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"230":"8e86c0e798e1be4b","6313":"030f68a455459397"}[chunkId] + ".js";
};